export default __webpack_public_path__ + "static/canada-7624945cc88a84616389d92dddc21835.png";